import styled from 'styled-components';

import { theme } from '../../theme';

const { colors, sizes, radius } = theme;

export const Input = styled.input`
  appearance: none;
  width: 18px;
  height: 18px;
  background-color: transparent;
  border: 2px solid ${colors.neutral.ink.lightest};
  border-radius: ${radius.base};
  cursor: pointer;
  flex-shrink: 0;

  transition:
    box-shadow 0.1s,
    background-color 0.1s;

  &:checked {
    background-color: ${colors.secondary.blue.base};
    border-color: ${colors.secondary.blue.base};
    background-image: url("data:image/svg+xml;utf-8,<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M8.56846 16.3657L3.86697 11.6642L2.2998 13.2313L8.56846 19.5L22.0013 6.06716L20.4341 4.5L8.56846 16.3657Z' fill='white' /></svg>");
    background-repeat: no-repeat;
    background-size: ${sizes[4]};
    background-position: center;
  }

  &:hover {
    border-color: ${colors.secondary.blue.base};
  }

  &:active {
    border-color: ${colors.secondary.blue.base};
  }

  &:focus {
    box-shadow: 0 0 0 4px ${colors.secondary.blue.light};
    outline: 0;
  }

  &:indeterminate {
    background-color: ${colors.secondary.blue.base};
    border-color: ${colors.secondary.blue.base};
    background-image: url("data:image/svg+xml;utf-8,<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='5' y='11' width='14' height='3' fill='white'/></svg>");
    background-repeat: no-repeat;
    background-size: ${sizes[4]};
    background-position: center;
  }

  &:disabled {
    box-shadow: none;
    background-color: ${colors.neutral.grey.base};
    border-color: ${colors.neutral.grey.base};
    color: ${colors.neutral.ink.light};
    cursor: default;
  }

  &:checked:disabled {
    background-image: url("data:image/svg+xml;utf-8,<svg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M8.56846 16.3657L3.86697 11.6642L2.2998 13.2313L8.56846 19.5L22.0013 6.06716L20.4341 4.5L8.56846 16.3657Z' fill='%23637381' /></svg>");
  }

  &:indeterminate:disabled {
    background-image: url("data:image/svg+xml;utf-8,<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='5' y='11' width='14' height='3' fill='%23637381'/></svg>");
  }
`;
